<template>
  <div>
    <navbar></navbar>
    <section id="espaco"></section>

    <section id="conteudo">
      <div class="container-fluid">
        <div class="row">
          <div class="sidebar-container">
            <sidebar v-show="true"></sidebar>
          </div>
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <router-view></router-view>
          </fade-transition>
        </div>
      </div>
    </section>

    <content-footer></content-footer>
  </div>
</template>
<script>
  import Navbar from "@/components/Navbar/Navbar.vue";
  import Sidebar from "@/components/Navbar/Sidebar.vue";
  import ContentFooter from "./ContentFooter.vue";
  import { FadeTransition } from "vue2-transitions";

  export default {
    components: {
      Navbar,
      Sidebar,
      ContentFooter,
      FadeTransition,
    },
    data() {
      return {
        sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      };
    },

    mounted() {
      $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
          // On-page links
          if (
            location.pathname.replace(/^\//, "") ==
              this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
          ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              $("html, body").animate(
                {
                  scrollTop: target.offset().top,
                },
                1000,
                function () {
                  // Callback after animation
                  // Must change focus!
                  var $target = $(target);
                  $target.focus();
                  if ($target.is(":focus")) {
                    // Checking if the target was focused
                    return false;
                  } else {
                    $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                  }
                }
              );
            }
          }
        });

      var window_top = $(window).scrollTop() + 1;
      if (window_top > 35) {
        $("header").addClass("drop");
        $("#up").css({ opacity: "1" });
      } else {
        $("header").removeClass("drop");
        $("#up").css({ opacity: "0" });
      }
      $(window).scroll(function () {
        var window_top = $(window).scrollTop() + 1;
        if (window_top > 35) {
          $("header").addClass("drop");
          $("#up").css({ opacity: "1" });
        } else {
          $("header").removeClass("drop");
          $("#up").css({ opacity: "0" });
        }
      });

      $(".blc-segundo .txt , #opt_menu .menu-lateral .item-menu .txt").click(
        function () {
          $(
            ".blc-segundo .txt .sub , #opt_menu .menu-lateral .item-menu .txt .sub"
          ).slideToggle();
        }
      );

      //----- Contador

      if ($.fn.counterUp) {
        $(".countercd").counterUp({
          delay: 10,
          time: 2000,
        });
      }
    },
  };
</script>
<style lang="scss">

.sidebar-container{
  width: 165px;
  flex-shrink: 0;
}

</style>
